import ExperienceInfoContent from './ExperienceInfoContent';

export default ExperienceInfoContent;
